<div
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2 sp-table__sticky-header">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'STORES.PAYMENT_METHODS_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    *ngIf="qinetic_payment_sources?.length"
    class="sp-width__full sp-margin__top-x2 sp-company-details-general-payment-methods__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <div class="sp-payment-sources-data-list__item sp-cursor__pointer">
      <div class="sp-background__primary-light sp-padding sp-border-radius__s sp-height__full">
        <div class="sp-row__end">
          <p class="sp-margin__right">
            {{ 'STORES.LIQUIDATION_BANK_ACCOUNT_LABEL' | translate }}
          </p>
          <mat-icon> account_balance </mat-icon>
        </div>

        <h2 class="sp-text__center sp-margin__top-x2 sp-margin__auto">
          {{ qinetic_payment_sources?.[0]?.iban || '' | translate }}
        </h2>
      </div>
    </div>
  </div>

  <div
    *ngIf="!qinetic_payment_sources?.length"
    class="sp-width__full sp-margin__top-x2 sp-company-details-general-payment-methods__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <div class="sp-payment-sources-data-list__item sp-cursor__pointer">
      <div class="sp-background__primary-light sp-padding sp-border-radius__s sp-height__full">
        <div class="sp-row__end">
          <p class="sp-margin__right">
            {{ 'STORES.LIQUIDATION_BANK_ACCOUNT_LABEL' | translate }}
          </p>
          <mat-icon> account_balance </mat-icon>
        </div>

        <h2 class="sp-text__center sp-margin__top-x2 sp-margin__auto">
          {{ 'COMPANIES.NO_BANK_ACCOUNT_FOUND_LABEL' | translate }}
        </h2>
      </div>
    </div>
  </div>

  <div
    *ngIf="stripe_payment_sources?.length"
    class="sp-width__full sp-margin__top-x2 sp-company-details-general-payment-methods__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <div class="sp-payment-sources-data-list__item sp-cursor__pointer">
      <div class="sp-background__primary-light sp-padding sp-border-radius__s sp-height__full">
        <div class="sp-row__end">
          <p class="sp-margin__right">
            {{ 'STORES.REFUNDS_BANK_ACCOUNT_LABEL' | translate }}
          </p>
          <mat-icon> account_balance </mat-icon>
        </div>

        <h2 class="sp-text__center sp-margin__top-x2 sp-margin__auto">
          ****{{ stripe_payment_sources?.[0]?.stripe_sepa_debit?.last4 || '' | translate }}
        </h2>
      </div>
    </div>
  </div>

  <div
    *ngIf="!stripe_payment_sources?.length"
    class="sp-width__full sp-margin__top-x2 sp-company-details-general-payment-methods__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <div class="sp-payment-sources-data-list__item sp-cursor__pointer">
      <div class="sp-background__primary-light sp-padding sp-border-radius__s sp-height__full">
        <div class="sp-row__end">
          <p class="sp-margin__right">
            {{ 'STORES.REFUNDS_BANK_ACCOUNT_LABEL' | translate }}
          </p>
          <mat-icon> account_balance </mat-icon>
        </div>

        <h2 class="sp-text__center sp-margin__top-x2 sp-margin__auto">
          {{ 'COMPANIES.NO_BANK_ACCOUNT_FOUND_LABEL' | translate }}
        </h2>
      </div>
    </div>
  </div>
</div>
